import { ClaimType } from '../enum/claimtype.enum';
import { CreditorType } from '../enum/creditortype.enum';
import { AccountType } from '../enum/accounttype.enum';
import { PreferentialRightGroup } from '../enum/preferentialrightgroup.enum';
import { CreditorPreferentialRight } from '../interfaces/creditorPreferentialRight.interface';

const claimTypeLabels: Record<number, string> = {
  [ClaimType.Bank]: 'Banklån',
  [ClaimType.Rent]: 'Hyresskuld',
  [ClaimType.Delivery]: 'Leverantörsskuld',
  [ClaimType.Salary]: 'Lönefordran',
  [ClaimType.Tax]: 'Skatt',
  [ClaimType.Other]: 'Övrig fordran'
};

export function formatClaimType(type?: ClaimType | number | null): string {
  if (type === null || type === undefined) return '';
  return claimTypeLabels[type] ?? '';
}

const creditorTypeLabels: Record<number, string> = {
  [CreditorType.Privatperson]: 'Privatperson',
  [CreditorType.Foretag]: 'Företag',
  [CreditorType.Myndighet]: 'Myndighet',
  [CreditorType.Bank]: 'Bank',
  [CreditorType.Annat]: 'Övrigt'
};

export function formatCreditorType(type?: CreditorType | number | null): string {
  if (type === null || type === undefined) return '';
  return creditorTypeLabels[type] ?? '';
}

const accountTypeLabels: Record<number, string> = {
  [AccountType.Swedish]: 'Svenskt bankkonto',
  [AccountType.Iban]: 'IBAN',
  [AccountType.OtherInternational]: 'Annat internationellt konto',
  [AccountType.Plusgiro]: 'Plusgiro',
  [AccountType.Bankgiro]: 'Bankgiro'
};

export function formatAccountType(type?: AccountType | number | null): string {
  if (type === null || type === undefined) return '';
  return accountTypeLabels[type] ?? '';
}

const preferentialRightGroupLabels: Record<number, string> = {
  [PreferentialRightGroup.Sarskild]: 'Särskild förmånsrätt',
  [PreferentialRightGroup.Allman]: 'Allmän förmånsrätt',
  [PreferentialRightGroup.Oprioriterad]: 'Oprioriterad',
  [PreferentialRightGroup.Efterstalld]: 'Efterställd'
};

export function formatPreferentialRightGroup(
  group?: PreferentialRightGroup | number | null
): string {
  if (group === null || group === undefined) return '';
  return preferentialRightGroupLabels[group] ?? '';
}

export function formatPreferentialRightName(
  preferentialRightId: string | null | undefined,
  preferentialRights: CreditorPreferentialRight[] | null | undefined
): string {
  if (!preferentialRightId || !preferentialRights?.length) {
    return '';
  }

  const match = preferentialRights.find(x => x.id === preferentialRightId);
  return match?.name ?? '';
}